import { Component, Input, OnInit } from '@angular/core';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-attributes-useradmin',
    templateUrl: './attributes-useradmin.component.html',
    styleUrls: ['./attributes-useradmin.component.scss']
})
export class AttributesUseradminComponent implements OnInit {
    @Input() public usersAttributes: any;
    @Input() public attributeGroups: string[];

    constructor(
        private uaService: UserAdminService
    ) { }

    ngOnInit(): void {
    }

}
